import { useTranslation } from 'react-i18next';

import { cn } from '@muzly/lib/utils';

/**
 * Mascot — 시안의 분홍 캐릭터. 설문 완료·진단 안내·소음 안내 화면이 같은 그림을 쓴다.
 *
 * `docs/figma/assets/mascot-default.webp`(4096px)를 640px로 줄여 `public/brand/`에 둔다 —
 * 원본은 4MB라 그대로 실으면 이 그림 하나가 번들의 나머지를 다 합친 것보다 커진다.
 *
 * `alt`가 빈 문자열이 아닌 이유: 이 그림이 있는 화면들은 본문이 한 줄뿐이라, 장식으로
 * 숨기면 스크린리더에 제목과 버튼 사이가 텅 빈다.
 */
export const Mascot = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <img
      src="/brand/mascot.png"
      alt={t('web.brand.mascotAlt')}
      className={cn('h-auto select-none', className)}
    />
  );
};
